module.exports = __webpack_public_path__ + "assets/img/problem_icon.3079261e.png";